<template>
    <v-layout justify-center>
        <v-responsive max-width="1140px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span> {{ title }} </span>
            </div>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">기본정보</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-row class="ma-n2">
                            <v-col class="pa-2" cols="12" v-if="isRoot">
                                <v-row class="mt-2 mb-n2 mx-n2">
                                    <v-col class="pa-2" cols="auto">
                                        <v-img v-if="lawyer.image" max-width="48" max-height="48" :src="createObjectURL(lawyer.image)" contain></v-img>
                                        <v-responsive v-else width="48" height="48" class="grey lighten-2">
                                            <v-row align="center" class="fill-height" justify="center"><v-icon color="black">mdi-pencil</v-icon></v-row>
                                        </v-responsive>
                                    </v-col>
                                    <v-col class="pa-2">
                                        <v-file-input v-model="lawyer.image" label="변호사 이미지" persistent-placeholder class="ma-0" show-size accept="image/*"></v-file-input>
                                    </v-col>
                                    <v-col class="pa-2" cols="12">
                                        <v-divider />
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col class="pa-2" cols="12" v-if="isRoot">
                                <v-row class="ma-n2">
                                    <v-col class="pa-2" cols="12" md="">
                                        <v-text-field v-model="lawyer.code" label="코드" persistent-placeholder hide-details />
                                    </v-col>
                                    <v-col class="pa-2" cols="12" md="">
                                        <v-select v-model="lawyer.local" label="언어" :items="['ko', 'en']" persistent-placeholder hide-details />
                                    </v-col>
                                    <v-col class="pa-2" cols="12" md="">
                                        <v-text-field v-model="lawyer.index" label="노출순서" persistent-placeholder hide-details type="number" />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col class="pa-2" cols="6" lg="3">
                                <v-text-field v-model="lawyer.name" label="이름" persistent-placeholder hide-details />
                            </v-col>
                            <v-col class="pa-2" cols="6" lg="3">
                                <v-text-field v-model="lawyer.rank" label="직급" persistent-placeholder hide-details />
                            </v-col>
                            <v-col class="pa-2" cols="6" lg="3">
                                <v-text-field v-model="lawyer.phone" label="전화번호" persistent-placeholder hide-details />
                            </v-col>
                            <v-col class="pa-2" cols="6" lg="3">
                                <v-text-field v-model="lawyer.email" label="이메일" persistent-placeholder hide-details />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">간단 소개</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="lawyer.about" outlined hide-details />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">소개</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea v-model="lawyer.section1.txt" outlined hide-details />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">업무분야</div>
                    <v-spacer />
                </v-layout>

                <v-card class="mt-2">
                    <v-row align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" class="mr-4" @click="setItem"><v-icon left size="16">mdi-plus</v-icon>항목 추가</v-btn>
                            <v-btn small color="red" elevation="4" outlined class="mr-4" @click="deleteItem"><v-icon left size="16">mdi-delete-outline</v-icon>항목 삭제</v-btn>
                        </v-col>
                    </v-row>

                    <div v-for="(section2, index) in lawyer.section2" :key="index">
                        <v-divider />
                        <v-card-text class="py-0">
                            <template>
                                <v-row align="center">
                                    <v-col cols="2">
                                        <v-textarea v-model="section2.title" rows="1" dense outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-col v-for="(column, index) in section2.columns" :key="index">
                                            <v-textarea v-model="column.txt" rows="1" dense outlined hide-details />
                                        </v-col>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-col>
                                            <v-btn small color="primary" elevation="4" @click="setColumn(index)"><v-icon left size="16">mdi-plus</v-icon>행 추가</v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn small outlined color="red" @click="deleteColumn(index)"><v-icon left size="16">mdi-delete-outline</v-icon>행 삭제</v-btn>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </div>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">학력사항</div>
                    <v-spacer />
                </v-layout>

                <v-card class="mt-2">
                    <v-row align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" class="mr-4" @click="setSection3Column"><v-icon left size="16">mdi-plus</v-icon>항목 추가</v-btn>
                            <v-btn small color="red" elevation="4" outlined class="mr-4" @click="deleteSection3Column"><v-icon left size="16">mdi-delete-outline</v-icon>항목 삭제</v-btn>
                        </v-col>
                    </v-row>

                    <div>
                        <v-divider />
                        <v-card-text class="py-0">
                            <template>
                                <v-row v-for="(section3, index) in lawyer.section3" :key="index" align="center">
                                    <v-col cols="2">
                                        <v-textarea v-model="section3.title" rows="1" dense outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-textarea v-model="section3.txt" rows="1" dense outlined hide-details />
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </div>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">경력사항</div>
                    <v-spacer />
                </v-layout>

                <v-card class="mt-2">
                    <v-row align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" class="mr-4" @click="setSection4Column"><v-icon left size="16">mdi-plus</v-icon>항목 추가</v-btn>
                            <v-btn small color="red" elevation="4" outlined class="mr-4" @click="deleteSection4Column"><v-icon left size="16">mdi-delete-outline</v-icon>항목 삭제</v-btn>
                        </v-col>
                    </v-row>

                    <div>
                        <v-divider />
                        <v-card-text class="py-0">
                            <template>
                                <v-row v-for="(section4, index) in lawyer.section4" :key="index" align="center">
                                    <v-col cols="2">
                                        <v-textarea v-model="section4.title" rows="1" dense outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-textarea v-model="section4.txt" rows="1" dense outlined hide-details />
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </div>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">주요 업무 수행 사례</div>
                    <v-spacer />
                </v-layout>

                <v-card class="mt-2">
                    <v-row align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" class="mr-4" @click="setSection5Item"><v-icon left size="16">mdi-plus</v-icon>항목 추가</v-btn>
                            <v-btn small color="red" elevation="4" outlined class="mr-4" @click="deleteSection5Item"><v-icon left size="16">mdi-delete-outline</v-icon>항목 삭제</v-btn>
                        </v-col>
                    </v-row>

                    <div v-for="(section5, index) in lawyer.section5" :key="index">
                        <v-divider />
                        <v-card-text class="py-0">
                            <template>
                                <v-row align="center">
                                    <v-col cols="2">
                                        <v-textarea v-model="section5.title" rows="1" dense outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-row v-for="(column, index) in section5.columns" :key="index">
                                            <v-col cols="3">
                                                <v-textarea v-model="column.title" rows="1" dense outlined hide-details />
                                            </v-col>
                                            <v-col>
                                                <v-textarea v-model="column.txt" rows="1" dense outlined hide-details />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-col>
                                            <v-btn small color="primary" elevation="4" @click="setSection5Column(index)"><v-icon left size="16">mdi-plus</v-icon>행 추가</v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn small outlined color="red" @click="deleteSection5Column(index)"><v-icon left size="16">mdi-delete-outline</v-icon>행 삭제</v-btn>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </div>
                </v-card>
            </section>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto">
                    <v-btn v-bind="{ loading }" dark color="blue darken-2" elevation="4" @click="save()">저장</v-btn>
                </v-col>
                <v-col md="auto" sm="auto" v-if="isRoot && !isCreate">
                    <v-btn v-bind="{ loading }" dark color="error" elevation="4" @click="remove()">삭제</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initLawyer } from "@/assets/variables";

export default {
    props: {
        _id: { type: String, default: null },
    },
    data: () => ({
        lawyer: initLawyer(),

        loading: false,
    }),
    computed: {
        isRoot() {
            return (this.$store.state.payload?.scope || []).includes("root");
        },
        isCreate() {
            return this._id == "create";
        },
        local() {
            return this.$route.query.local;
        },
        title() {
            let title = "변호사";
            if (false);
            else if (this.isCreate) title += " 추가하기";
            else title += " 수정하기";

            return title;
        },
        payload() {
            return this.$store.state.payload || {};
        },
    },
    methods: {
        async init() {
            if (this.isCreate) {
                this.lawyer = initLawyer({ local: this.local });
                this.loading = false;
                return;
            }

            this.loading = true;

            let { _id } = this;
            try {
                let { lawyer } = await api.console.lawyers.get({ _id });
                try {
                    if (lawyer.image) lawyer.image = await api.getResource(lawyer.image, true);
                } catch (error) {
                    delete lawyer.image;
                }

                if (this._id == _id) this.lawyer = initLawyer(lawyer);
            } finally {
                if (this._id == _id) this.loading = false;
            }
        },
        async save() {
            let { image, ...form } = this.lawyer;

            let { post, put } = api.console.lawyers;
            let { lawyer } = await (this.isCreate ? post : put)(form);

            if (image) await api.console.lawyers.postThumb(lawyer, image);

            alert("저장되었습니다");
        },
        async remove() {
            let go = confirm("해당 변호사를 삭제하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { _id } = this;
                await api.console.lawyers.delete({ _id });
            } finally {
                this.loading = false;
                this.$router.replace("/console");
            }
        },
        setItem() {
            this.lawyer.section2.push({ title: null, columns: [{ txt: null }] });
        },
        deleteItem() {
            this.lawyer.section2.pop();
        },
        setColumn(index) {
            this.lawyer.section2[index].columns.push({ txt: null });
        },
        deleteColumn(index) {
            this.lawyer.section2[index].columns.pop();
        },
        setSection3Column() {
            this.lawyer.section3.push({ title: null, txt: null });
        },
        deleteSection3Column() {
            this.lawyer.section3.pop();
        },
        setSection4Column() {
            this.lawyer.section4.push({ title: null, txt: null });
        },
        deleteSection4Column() {
            this.lawyer.section4.pop();
        },
        setSection5Item() {
            this.lawyer.section5.push({ title: null, columns: [{ txt: null }] });
        },
        deleteSection5Item() {
            this.lawyer.section5.pop();
        },
        setSection5Column(index) {
            this.lawyer.section5[index].columns.push({ title: null, txt: null });
        },
        deleteSection5Column(index) {
            this.lawyer.section5[index].columns.pop();
        },
        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return;
            }
        },
    },
    watch: {
        _id() {
            this.init();
        },
        local() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
